export const log = (item, name, hideLogs, isError) => {
    if(process.env.REACT_APP_NODE_ENV === "development") {
        if(name && !hideLogs && isError) {
            console.error(`${name}`, item);
        } else if (!hideLogs && isError) {
            console.error(item);
        } else if(name && !hideLogs) {
            console.log(`${name}`, item);
        } else if (!hideLogs) {
            console.log(item);
        }
    }
};
  
export const logTime = (name, end, hideLogs) => {
    if(process.env.REACT_APP_NODE_ENV === "development") {
        if(end && !hideLogs) {
            console.timeEnd(name);
        } else if(!hideLogs) {
            console.time(name);
        }
    }
};